import iconNotification from '../../assets/images/icons/notification.png'
import {eventTag, formatDatetimePt} from "../../services/utils";
import Acronyms from "../acronyms";
import {useEffect, useRef, useState} from "react";
import {BaSeButton} from "@base/react";
import Loading from "../loading";
import {toast} from "react-toastify";
import ToastContent from "../toastContent";
import iconSuccess from "../../assets/images/icons/check-circle.png";
import ApiShare from "../../services/share";
import iconError from "../../assets/images/icons/exclamation-octagon.png";
import InputSelect from "../select";
import "./index.scss";

const api = ApiShare()

const event = {
  name: "notifications",
  category: "notifications",
  action: "click",
}

const roleOptions = [
  { value: "visualizador", label: "Visualizador" },
  { value: "editor", label: "Editor" },
  { value: "consultor", label: "Consultor" },
]

const isPostCreditInvite = (item) => {
  return item?.data?.type === "post_credit"
}

const Notifications = () => {
  const notificationsRef = useRef(null)
  const intervalRef = useRef(null)
  const [wasOpened, setWasOpened] = useState(false)
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedRoles, setSelectedRoles] = useState({})
  const [notifications, setNotifications] = useState({
    data: [],
    amountUnread: 0,
  })

  const handleRoleChange = (notificationId, role) => {
    setSelectedRoles((prevState) => ({
      ...prevState,
      [notificationId]: role,
    }))
  }

  const CardNotification = ({item}) => {
    const selectedRole = selectedRoles[item?.id] || null
    const isRoleNotSelected = !selectedRole
    const isRedirectNotification = item?.type === "redirect"
    const notificationDisplayName = isRedirectNotification
      ? item?.data?.cnpj_name
      : item?.data?.user_invited
    const showInviteActions = !item.is_read && item?.type === 'invite'
    const showDefaultActions = !item.is_read && item?.type !== 'info' && item?.type !== 'invite' && !isRedirectNotification
    const postCreditInvite = isPostCreditInvite(item)

    return (
      <div className="notifications__card">
        <div className="notifications__card--avatar">
          {
            !item.is_read ? (
              <span className="notifications__flag"></span>
            ) : ""
          }
          <Acronyms nameUser={notificationDisplayName} background={"#2E5DE6"} />
        </div>
        <div className="notifications__card--info">
          <p className="notifications__card--text"><strong>{item?.title}</strong> <span>•</span> <span>{formatDatetimePt(item?.created_at)}</span></p>
          <h3 className="notifications__card--user">{notificationDisplayName}</h3>
          <p className={`notifications__card--text ${item?.status}`}>{item?.message}</p>
          {
            showInviteActions ? (
              <>
                <div className="notifications__card--select">
                  <InputSelect
                    title="Perfil de acesso"
                    options={roleOptions}
                    placeholder="Selecione o papel"
                    value={selectedRole}
                    className="input-select--inline-options"
                    onChange={(value) => handleRoleChange(item?.id, value)}
                  />
                </div>
                <div className="notifications__card--buttons">
                  <BaSeButton
                    color="#2E5DE6"
                    value="Aceitar"
                    isDisabled={isRoleNotSelected}
                    onClick={() => {
                      if (isRoleNotSelected) return
                      eventTag(event?.name, "atendimento", event?.action, "Aceitar")
                      changeStatusNotifications(item?.id, item?.data?.invite_id, 'aceito', selectedRole, postCreditInvite)
                    }}
                  />
                  <button
                    type="button"
                    className="btn-white-outline"
                    onClick={() => {
                      eventTag(event?.name, "atendimento", event?.action, "Recusar")
                      changeStatusNotifications(item?.id, item?.data?.invite_id, 'rejeitado', selectedRole, postCreditInvite)
                    }}
                  >
                    Recusar
                  </button>
                </div>
              </>
            ) : showDefaultActions ? (
              <div className="notifications__card--buttons">
                <button
                  type="button"
                  className="btn-white-outline"
                  onClick={() => {
                    eventTag(event?.name, (item?.type === 'invite' ? "atendimento" : event?.category), event?.action, "Recusar")
                    changeStatusNotifications(item?.id, item?.data?.invite_id, 'rejeitado')
                  }}
                >
                  Recusar
                </button>
                <BaSeButton
                  color="#2E5DE6"
                  value="Aceitar"
                  onClick={() => {
                    eventTag(event?.name, (item?.type === 'invite' ? "atendimento" : event?.category), event?.action, "Aceitar")
                    changeStatusNotifications(item?.id, item?.data?.invite_id, 'aceito')
                  }}
                />
              </div>
            ) : ""
          }
        </div>
      </div>
    )
  }
  const getNotifications = async () => {
    setLoading(true)
    try {
      const { data } = await api.notifications()
      if (data) {
        setNotifications({
          data: data || [],
          amountUnread: data.filter((item) => !item.is_read).length,
        })
      }
    } catch (e) {
      console.warn(e)
    } finally {
      setLoading(false)
    }
  }
  const changeStatusNotifications = async (id, inviteId, status, role = null, postCreditInvite = false) => {
    if (!id ||!inviteId || !status) return false

    setLoading(true)
    try {
      const payload = role ? { role, status } : { status }

      if (postCreditInvite) {
        await api.changeStatusPostCredit(inviteId, payload)
      } else {
        await api.changeStatus(inviteId, payload)
      }
      await api.notificationsMakeRead(id)

      toast.success(
        <ToastContent
          title="Sucesso!"
          description="Notificação atualizada com sucesso."
        />,
        { icon: () => <img src={iconSuccess} alt="icon" /> }
      )

      await getNotifications?.()

      return true
    } catch (e) {
      const {message, details} = e
      console.warn("error - ", details)
      toast.error(
        <ToastContent
          title="Falha!"
          description={message || "Ocorreu um erro ao atualizar notificações. Tente novamente!"}
        />,
        {
          icon: () => <img src={iconError} alt="icon" />,
          autoClose: 5000,
          pauseOnFocusLoss: false,
        }
      )

      if (details?.expired) {
        await api.notificationsMakeRead(id)
      }

    } finally {
      setLoading(false)
    }
  }
  const makeAllRead = async () => {
    const data = notifications?.data
    const infoNotifications = data.filter((item) => item.type === "info") || null
    if (infoNotifications) {
      await Promise.allSettled(
        infoNotifications.map(item => api.notificationsMakeRead(item.id))
      )

      await getNotifications()
      setWasOpened(false)
    }
  }

  useEffect(() => {
    getNotifications()

    intervalRef.current = setInterval(getNotifications, 1000 * 60)
  }, [])

  // eslint-disable-next-line
  useEffect(() => {
    if (!open) {
      if (wasOpened) {
        makeAllRead()
      }
      return
    } else {
      setWasOpened(true)
    }

    const handlePointer = (e) => {
      if (notificationsRef.current && !notificationsRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    const handleEsc = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', handlePointer)
    document.addEventListener('touchstart', handlePointer, { passive: true })
    document.addEventListener('keydown', handleEsc)

    return () => {
      document.removeEventListener('mousedown', handlePointer)
      document.removeEventListener('touchstart', handlePointer)
      document.removeEventListener('keydown', handleEsc)
    }

    // eslint-disable-next-line
  }, [open])

  return (
    <div className="notifications" ref={notificationsRef}>
      <button
        type="button"
        className="btn-without-style notifications__button"
        onClick={() => {
          setOpen(!open)
          eventTag(event?.name, event?.category, event?.action, "Notificações")
        }}>
        {
          notifications.amountUnread > 0 ? (
            <span className="notifications__flag">{notifications.amountUnread > 9 ? '9+' : notifications.amountUnread}</span>
          ) : ""
        }
        <img src={iconNotification} alt="Notificações" title="Notificações" />
      </button>
      <div className={`notifications__wrapper ${open ? 'opened' : ''}`}>
        <div className="notifications__wrapper--content">
          <div className="notifications__wrapper--header">
            <h6>Notificações</h6>

            <button
              type="button"
              className="btn-without-style notifications__btn-close"
              onClick={() => {
                setOpen(false)
                eventTag(event?.name, event?.category, event?.action, "Fechar notificações")
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
              >
                <path
                  d="M4.93996 3.9998L7.80663 1.1398C8.06804 0.878383 8.06804 0.454546 7.80663 0.193131C7.54521 -0.0682834 7.12137 -0.0682834 6.85996 0.193131L3.99996 3.0598L1.13996 0.193131C0.878545 -0.0682834 0.454707 -0.0682834 0.193293 0.193131C-0.0681221 0.454546 -0.0681221 0.878383 0.193293 1.1398L3.05996 3.9998L0.193293 6.8598C0.0670842 6.98498 -0.00390625 7.15537 -0.00390625 7.33313C-0.00390625 7.51089 0.0670842 7.68129 0.193293 7.80646C0.31847 7.93267 0.488868 8.00366 0.666626 8.00366C0.844384 8.00366 1.01478 7.93267 1.13996 7.80646L3.99996 4.9398L6.85996 7.80646C6.98514 7.93267 7.15553 8.00366 7.33329 8.00366C7.51105 8.00366 7.68145 7.93267 7.80663 7.80646C7.93283 7.68129 8.00383 7.51089 8.00383 7.33313C8.00383 7.15537 7.93283 6.98498 7.80663 6.8598L4.93996 3.9998Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
          <div className="notifications__wrapper--body">
            {
              loading ? (
                <div className="wrapper-loading-small">
                  <Loading small />
                </div>
              ) : notifications?.data.length ? (
                <ul>
                  {
                    notifications?.data.map((item) => (
                      <li key={item.id}>
                        <CardNotification item={item} />
                      </li>
                    ))
                  }
                </ul>
              ) : (
                <ul>
                  <li><div className="empty">Não há notificação.</div></li>
                </ul>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
